export default "/kiban/_next/static/images/countSimulationButton_hover-cf01457655014a99937bf94d7fe84593.png";